import React from "react";
import { connect } from "react-redux";
import {
  Button,
  Checkbox,
  Heading,
  InlineAlert,
  Pane,
  SelectField,
  toaster,
  Tooltip,
  InfoSignIcon,
} from "evergreen-ui";
import {
  getActivities,
  getCourtList,
  getPatternBookingSlots,
  updateCartData,
  verifySlotsAvailability,
} from "../external/actions";
import {
  addToCart,
  clearCart,
  getCurrentDate,
  getCurrentTime,
  getFormattedDate,
  getSlotId,
} from "../util";
import BackBar from "../components/backBar";
import DateRangePicker from "../components/dateRangePicker";
import TimeRangePicker from "../components/timeRangePicker";
import DaysSelector from "../components/daysSelector";
import Loader from "../components/loader";
import BulkBookingSlotsAvailabilityDialog from "../components/bulkBookingSlotsAvailabilityDialog";

class BulkBooking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      selectedActivityId: "-1",
      fromDate: getCurrentDate("YYYY-MM-DD"),
      toDate: getCurrentDate("YYYY-MM-DD"),
      currentDate: getCurrentDate("YYYY-MM-DD"),
      fromTime: new Date(),
      toTime: getCurrentTime("HH:mm:ss"),
      currentTime: getCurrentTime("HH:mm:ss"),
      allDaysIsChecked: false,
      days: [
        { day: "Mon", id: 0, checked: false },
        { day: "Tue", id: 1, checked: false },
        { day: "Wed", id: 2, checked: false },
        { day: "Thu", id: 3, checked: false },
        { day: "Fri", id: 4, checked: false },
        { day: "Sat", id: 5, checked: false },
        { day: "Sun", id: 6, checked: false },
      ],
      allCourtsIsChecked: false,
      courts: [],
      slotsAvailabilityDialogIsShown: false,
      invalidSport: false,
      invalidCourts: false,
      invalidDays: false,
      ignoreUnavailableSlots: true,
    };
    this.baseState = this.state;
  }

  componentDidMount = async () => {
    await this.props.dispatch(getActivities());
  };

  reset = async () => {
    await this.setState({
      ...this.baseState,
      fromDate: getCurrentDate("YYYY-MM-DD"),
      toDate: getCurrentDate("YYYY-MM-DD"),
      currentDate: getCurrentDate("YYYY-MM-DD"),
      fromTime: getCurrentTime("HH:mm:ss"),
      toTime: getCurrentTime("HH:mm:ss"),
      currentTime: getCurrentTime("HH:mm:ss"),
      ignoreUnavailableSlots: true,
      days: [
        { day: "Mon", id: 0, checked: false },
        { day: "Tue", id: 1, checked: false },
        { day: "Wed", id: 2, checked: false },
        { day: "Thu", id: 3, checked: false },
        { day: "Fri", id: 4, checked: false },
        { day: "Sat", id: 5, checked: false },
        { day: "Sun", id: 6, checked: false },
      ],
    });
  };

  back = async () => {
    await this.reset();
    this.props.history.push("/");
  };

  activityChange = async (activityId) => {
    await this.setState({
      loader: true,
      selectedActivityId: activityId,
      invalidCourts: false,
    });
    if (parseInt(activityId) === -1) {
      await this.setState({
        courts: [],
        loader: false,
      });
    } else {
      await this.props.dispatch(getCourtList({ activityId }));
      const { courtListData } = this.props;

      if (courtListData.requestStatus === -1) {
        this.setState({
          loader: false,
        });
      } else {
        await this.setState({
          courts:
            courtListData &&
            courtListData["courtList"] &&
            courtListData["courtList"].map((court) => {
              return {
                ...court,
                checked: false,
              };
            }),
          loader: false,
        });
      }
    }
    if (parseInt(activityId) !== -1) {
      await this.setState({
        invalidSport: false,
      });
    }
  };

  dateChange = (dateChangeData) => {
    this.setState({ ...dateChangeData });
  };

  timeChange = (timeChangeData) => {
    this.setState({ ...timeChangeData });
  };

  selectAllDays = async (status) => {
    let { days } = this.state;

    await this.setState({
      allDaysIsChecked: status,
      days: days.map((day) => {
        day.checked = status;
        return day;
      }),
    });
    if (days.filter((day) => day.checked).length) {
      await this.setState({
        invalidDays: false,
      });
    }
  };

  selectDay = async (id, status) => {
    let { days, allDaysIsChecked } = this.state;

    days = days.map((day) => {
      if (id === day.id) {
        day.checked = status;
      }
      return day;
    });
    allDaysIsChecked = days.filter((day) => day.checked === true).length === 7;
    await this.setState({
      allDaysIsChecked: allDaysIsChecked,
      days: days.map((day) => {
        if (id === day.id) {
          day.checked = status;
        }
        return day;
      }),
    });
    if (days.filter((day) => day.checked).length) {
      await this.setState({
        invalidDays: false,
      });
    }
  };

  selectAllCourts = async (status) => {
    let { courts } = this.state;

    await this.setState({
      allCourtsIsChecked: status,
      courts: courts.map((court) => {
        court.checked = status;
        return court;
      }),
    });
    if (courts.filter((court) => court.checked).length) {
      await this.setState({
        invalidCourts: false,
      });
    }
  };

  selectCourt = async (courtId, status) => {
    let { courts, allCourtsIsChecked } = this.state;

    courts = courts.map((court) => {
      if (courtId === court.courtId) {
        court.checked = status;
      }
      return court;
    });
    allCourtsIsChecked = courts.filter((court) => court.checked === true).length === courts.length;
    await this.setState({
      allCourtsIsChecked: allCourtsIsChecked,
      courts: courts.map((court) => {
        if (courtId === court.courtId) {
          court.checked = status;
        }
        return court;
      }),
    });
    if (courts.filter((court) => court.checked).length) {
      await this.setState({
        invalidCourts: false,
      });
    }
  };

  showSlotsAvailabilityDialog = async (status) => {
    await this.setState({
      slotsAvailabilityDialogIsShown: status,
    });
  };

  validateBulkBookingForm = async () => {
    const { selectedActivityId, courts, days } = this.state;
    let isValid = true;
    if (parseInt(selectedActivityId) === -1) {
      await this.setState({
        invalidSport: true,
      });
      isValid = false;
    }
    if (!courts.filter((court) => court.checked).length) {
      await this.setState({
        invalidCourts: true,
      });
      isValid = false;
    }
    if (!days.filter((day) => day.checked).length) {
      await this.setState({
        invalidDays: true,
      });
      isValid = false;
    }
    return isValid;
  };

  checkAvailability = async () => {
    const { courts, fromDate, toDate, fromTime, toTime, days, ignoreUnavailableSlots } = this.state;

    await this.setState({
      loader: true,
    });

    if (await this.validateBulkBookingForm()) {
      await this.props.dispatch(
        verifySlotsAvailability({
          courts: courts.filter((court) => court.checked).map((court) => court.courtId),
          startDate: fromDate,
          endDate: toDate,
          allSlots: false,
          startTime: fromTime,
          endTime: toTime === "00:00:00" ? "23:59:59" : toTime,
          days: days.filter((day) => day.checked).map((day) => day.id),
          ignoreUnavailableSlots,
        })
      );
      if (this.props.verifySlotsAvailabilityData) {
        if (this.props.verifySlotsAvailabilityData.requestStatus === 1) {
          await this.showSlotsAvailabilityDialog(true);
        } else {
          toaster.warning(this.props.verifySlotsAvailabilityData.message);
        }
      }
    }
    await this.setState({
      loader: false,
    });
  };

  cartBulkBookingSlots = async () => {
    const { verifySlotsAvailabilityData, activityData } = this.props;

    const { selectedActivityId, fromDate, toDate, fromTime, toTime, courts, days } = this.state;

    await this.setState({
      loader: true,
    });
    await this.props.dispatch(updateCartData(clearCart()));
    await this.props.dispatch(
      getPatternBookingSlots({
        activityId: selectedActivityId,
        startDate: fromDate,
        endDate: toDate,
        slots: verifySlotsAvailabilityData.data["availableSlots"],
      })
    );
    this.props.patternBookingSlotsData.cart.slots.forEach((slot) => {
      const date = getFormattedDate(slot["slotDate"], "YYYY-MM-DD", "ddd, Do MMM YY");
      const slotId = getSlotId({ date, slot });
      slot = {
        ...slot,
        courtId: slot.courtId,
        courtBrothers: slot.courtBrothers,
        courtName: slot.courtName,
        available: [
          {
            courtId: slot.courtId,
            courtBrothers: slot.courtBrothers,
            courtName: slot.courtName,
          },
        ],
        activityName: activityData["activities"][parseInt(selectedActivityId)],
      };
      this.props.dispatch(updateCartData(addToCart({ date, slot, slotId }, true)));
    });
    this.props.history.push({
      pathname: "/checkout",
      state: {
        isBulkBooking: true,
        bulkBookingData: {
          activityId: selectedActivityId,
          startDate: fromDate,
          endDate: toDate,
          startTime: fromTime,
          endTime: toTime,
          allSlots: false,
          courts: courts.filter((court) => court.checked).map((court) => court.courtId),
          days: days.filter((day) => day.checked).map((day) => day.id),
          activityName: activityData["activities"][parseInt(selectedActivityId)],
          courtNames: courts.filter((court) => court.checked).map((court) => court.courtName),
          dayNames: days.filter((day) => day.checked).map((day) => day.day),
        },
      },
    });
    await this.reset();
    await this.setState({
      loader: false,
    });
  };

  render() {
    const { activityData } = this.props;

    const {
      loader,
      allCourtsIsChecked,
      courts,
      fromDate,
      toDate,
      currentDate,
      fromTime,
      toTime,
      currentTime,
      days,
      allDaysIsChecked,
      slotsAvailabilityDialogIsShown,
      invalidSport,
      invalidCourts,
      invalidDays,
      selectedActivityId,
      ignoreUnavailableSlots,
    } = this.state;

    return (
      <React.Fragment>
        <BackBar back={this.back} title={"Bulk Booking"} />
        {loader && <Loader top={60} type={1} />}
        <BulkBookingSlotsAvailabilityDialog
          isShown={slotsAvailabilityDialogIsShown}
          showDialog={this.showSlotsAvailabilityDialog}
          cartBulkBookingSlots={this.cartBulkBookingSlots}
        />
        {activityData && (
          <Pane
            padding={10}
            minHeight={"100vw"}
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"space-between"}
          >
            <Pane paddingBottom={20} marginBottom={20} borderBottom={"default"}>
              <SelectField
                label={"SPORT"}
                onChange={(e) => this.activityChange(e.target.value)}
                marginBottom={0}
                isInvalid={invalidSport}
                validationMessage={invalidSport && "Please select a valid sport"}
                value={selectedActivityId}
              >
                <option value={-1}>Select Sport</option>
                {activityData &&
                  activityData["activities"] &&
                  Object.keys(activityData["activities"]).map((activity, index) => (
                    <option key={index} value={activity}>
                      {activityData["activities"][activity]}
                    </option>
                  ))}
              </SelectField>
            </Pane>
            {courts.length ? (
              <Pane
                paddingBottom={20}
                marginBottom={20}
                borderBottom={"default"}
                display={"flex"}
                flexDirection={"column"}
              >
                <Heading marginBottom={4} size={100} color={"#425A70"}>
                  COURTS
                </Heading>
                <Pane display={"flex"} flexWrap={"wrap"}>
                  <Checkbox
                    width={"25%"}
                    label='All Courts'
                    checked={allCourtsIsChecked}
                    onChange={(e) => this.selectAllCourts(e.target.checked)}
                    marginTop={4}
                    marginBottom={0}
                  />
                  {courts.map((court, index) => (
                    <Checkbox
                      width={"25%"}
                      key={index}
                      label={court.courtName}
                      checked={court.checked}
                      onChange={(e) => this.selectCourt(court.courtId, e.target.checked)}
                      marginTop={4}
                      marginBottom={0}
                    />
                  ))}
                </Pane>
                {invalidCourts && (
                  <InlineAlert intent='danger' marginTop={5}>
                    Please select a court
                  </InlineAlert>
                )}
              </Pane>
            ) : (
              <React.Fragment />
            )}
            <Pane
              paddingBottom={20}
              marginBottom={20}
              borderBottom={"default"}
              display={"flex"}
              flexDirection={"column"}
            >
              <Heading marginBottom={4} size={100} color={"#425A70"}>
                DATE
              </Heading>
              <DateRangePicker
                fromDate={fromDate}
                toDate={toDate}
                currentDate={currentDate}
                dateChange={this.dateChange}
              />
            </Pane>
            <Pane
              paddingBottom={15}
              marginBottom={15}
              borderBottom={"default"}
              display={"flex"}
              flexDirection={"column"}
            >
              <Heading marginBottom={4} size={100} color={"#425A70"}>
                DAYS
              </Heading>
              <DaysSelector
                days={days}
                allDaysIsChecked={allDaysIsChecked}
                selectAllDays={this.selectAllDays}
                selectDay={this.selectDay}
              />
              {invalidDays && (
                <InlineAlert intent='danger' marginTop={5}>
                  Please select a day
                </InlineAlert>
              )}
            </Pane>
            <Pane
              paddingBottom={20}
              marginBottom={5}
              borderBottom={"default"}
              display={"flex"}
              flexDirection={"column"}
            >
              <Heading marginBottom={4} size={100} color={"#425A70"}>
                TIME
              </Heading>
              <TimeRangePicker
                fromTime={fromTime}
                toTime={toTime}
                currentTime={currentTime}
                timeChange={this.timeChange}
              />
            </Pane>
            <Pane
              marginBottom={15}
              justifyContent=''
              flexDirection='row'
              borderBottom={"default"}
              alingItems='center'
              display={"flex"}
            >
              <Checkbox
                label='Ignore unavailable slots?'
                onChange={() => {
                  this.setState({ ignoreUnavailableSlots: !ignoreUnavailableSlots });
                }}
                checked={ignoreUnavailableSlots}
              />
              <Tooltip
                display='flex'
                justifyContent='center'
                alignItems='center'
                flexDirection='row'
             
                content='By deselecting this option, If a booking already exists for a date and court for the selected pattern, the slots for that date and court will not be booked.'
              >
                <InfoSignIcon marginLeft={6} marginTop={14} color="muted" marginRight={5} />
              </Tooltip>
            </Pane>
            <Pane display={"flex"} justifyContent={"space-between"}>
              <Button
                display={"flex"}
                width={"50%"}
                justifyContent={"center"}
                marginRight={10}
                onClick={this.reset}
              >
                Reset
              </Button>
              <Button
                display={"flex"}
                width={"50%"}
                justifyContent={"center"}
                marginLeft={10}
                appearance={"primary"}
                onClick={this.checkAvailability}
              >
                Check Availability
              </Button>
            </Pane>
          </Pane>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  activityData,
  courtListData,
  verifySlotsAvailabilityData,
  patternBookingSlotsData,
  cart,
}) => ({
  activityData,
  courtListData,
  verifySlotsAvailabilityData,
  patternBookingSlotsData,
  cart,
});

export default connect(mapStateToProps)(BulkBooking);
